@if (config) {
  <inventory-ui-item-pricing-table-base
    #itemPricingTable
    [config]="config"
    [items]="items()"
    [viewOnly]="viewOnly"
    [showRetailFrequencySuffix]="showRetailFrequencySuffix"
    (updatedItemRow)="onUpdatedItemRow($event)"
    (valid)="onValid($event)"
    (wholesaleTotal)="onWholesaleTotal($event)"
    (wholesaleSummaryChanged)="onWholesaleSummary($event)"
  />
  @if (config?.canAddItems && !viewOnly) {
    <div class="selector-button-container">
      <button type="button" color="primary" mat-stroked-button class="selector-button" (click)="onAddItems()">
        + {{ 'INVENTORY_UI.COMMON.ACTIONS.ADD_ITEMS' | translate }}
      </button>
    </div>
  }
}
